export const BRAND = import.meta.env.VITE_BRAND || 'connect';

import defaultImg from '../../../assets/imgs/no-image.png';

import mnkLogo from '../../../assets/imgs/brand-logos/mnk_logo.svg';
import isLogo from '../../../assets/imgs/brand-logos/is_logo.svg';
import connectLogo from '../../../assets/imgs/brand-logos/connect_logo.svg';
import suraLogo from '../../../assets/imgs/brand-logos/sura_logo.png';
import bcrLogo from '../../../assets/imgs/brand-logos/logo_bcrcr.svg';
import insLogo from '../../../assets/imgs/brand-logos/ins-logo.svg';
import lafiseLogo from '../../../assets/imgs/brand-logos/lafise_logo.png';

import IsWelcomeImg from '../../../assets/imgs/il_proceso.svg';
import SuraWelcomeImg from '../../../assets/imgs/il_proceso_sura.svg';
import BcrWelcomeImg from '../../../assets/imgs/il_proceso_bcr.svg';
import ConnectWelcomeImg from '../../../assets/imgs/il_proceso_connect.svg';
import LafiseWelcomeImg from '../../../assets/imgs/il_proceso_lafise.svg';

import IsExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior.svg';
import SuraExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior-sura.svg';
import BcrExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior - bcr.svg';
import ConnectExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior-connect.svg';
import InsExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior - ins.svg';
import LafiseExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior - lafise.svg';

import IsInteriorIcon from '../../../assets/imgs/photo-menu/i-interior.svg';
import SuraInteriorIcon from '../../../assets/imgs/photo-menu/i-interior-sura.svg';
import BcrInteriorIcon from '../../../assets/imgs/photo-menu/i-interior - bcr.svg';
import ConnectInteriorIcon from '../../../assets/imgs/photo-menu/i-interior-connect.svg';
import InsInteriorIcon from '../../../assets/imgs/photo-menu/i-interior - ins.svg';
import LafiseInteriorIcon from '../../../assets/imgs/photo-menu/i-interior - lafise.svg';

import IsDocumentIcon from '../../../assets/imgs/photo-menu/i-documento.svg';
import SuraDocumentIcon from '../../../assets/imgs/photo-menu/i-documento-sura.svg';
import BcrDocumentIcon from '../../../assets/imgs/photo-menu/i-documento - bcr.svg';
import ConnectDocumentIcon from '../../../assets/imgs/photo-menu/i-documento-connect.svg';
import InsDocumentIcon from '../../../assets/imgs/photo-menu/i-documento - ins.svg';
import LafiseDocumentIcon from '../../../assets/imgs/photo-menu/i-documento - lafise.svg';

import IsVideoIcon from '../../../assets/imgs/photo-menu/i-360video.svg';
import SuraVideoIcon from '../../../assets/imgs/photo-menu/i-360video-sura.svg';
import BcrVideoIcon from '../../../assets/imgs/photo-menu/i-360video - bcr.svg';
import ConnectVideoIcon from '../../../assets/imgs/photo-menu/i-360video-connect.svg';
import InsVideoIcon from '../../../assets/imgs/photo-menu/i-360video - ins.svg';
import LafiseVideoIcon from '../../../assets/imgs/photo-menu/i-360video - lafise.svg';

import IsPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate.svg';
import SuraPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_sura.svg';
import BcrPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_bcr.svg';
import ConnectPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_connect.svg';
import InsPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_ins.svg';
import LafisePlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_lafise.svg';

import IsFrontIcon from '../../../assets/imgs/photo-placeholders/exterior/front.svg';
import SuraFrontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_sura.svg';
import BcrFontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_bcr.svg';
import ConnectFrontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_connect.svg';
import InsFontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_ins.svg';
import LafiseFrontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_lafise.svg';

import IsLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left.svg';
import SuraLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_sura.svg';
import BcrLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_bcr.svg';
import ConnectLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_connect.svg';
import InsLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_ins.svg';
import LafiseLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_lafise.svg';

import IsRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right.svg';
import SuraRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_sura.svg';
import BcrRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_bcr.svg';
import ConnectRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_connect.svg';
import InsRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_ins.svg';
import LafiseRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_lafise.svg';

import IsBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back.svg';
import SuraBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_sura.svg';
import BcrBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_bcr.svg';
import ConnectBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_connect.svg';
import InsBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_ins.svg';
import LafiseBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_lafise.svg';

import IsScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan.svg';
import SuraScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_sura.svg';
import BcrScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_bcr.svg';
import ConnectScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_connect.svg';
import InsScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_ins.svg';
import LafiseScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_lafise.svg';

import IsInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1.svg';
import SuraInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1_sura.svg';
import BcrInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1_bcr.svg';
import ConnectInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1_connect.svg';
import InsInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1_ins.svg';
import LafiseInteriorPlaceIcon from '../../../assets/imgs/photo-placeholders/interior/i-interior-1_lafise.svg';

import IsVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin.svg';
import SuraVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_sura.svg';
import BcrVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_bcr.svg';
import ConnectVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_connect.svg';
import InsVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_ins.svg';
import LafiseVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_lafise.svg';

import IsSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer.svg';
import SuraSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_sura.svg';
import BcrSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_bcr.svg';
import ConnectSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_connect.svg';
import InsSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_ins.svg';
import LafiseSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_lafise.svg';

import IsDekraIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan.svg';
import BcrDekraIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_bcr.svg';
import ConnectDekraIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_connect.svg';
import InsDekraIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_ins.svg';
import LafiseDekraIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_lafise.svg';

import IsTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan.svg';
import SuraTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_sura.svg';
import BcrTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_bcr.svg';
import ConnectTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_connect.svg';
import InsTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_ins.svg';
import LafiseTrunkIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_lafise.svg';

import IsfinishIcon from '../../../assets/imgs/i-finalizado.svg';
import SuraFinishIcon from '../../../assets/imgs/i-finalizado_sura.svg';
import BcrFinishIcon from '../../../assets/imgs/i-finalizado_bcr.svg';
import ConnectFinishIcon from '../../../assets/imgs/i-finalizado_connect.svg';
import InsFinishIcon from '../../../assets/imgs/i-finalizado_ins.svg';
import LafiseFinishIcon from '../../../assets/imgs/i-finalizado_lafise.svg';

import IsCompleteImg from '../../../assets/imgs/complete.svg';
import SuraCompleteImg from '../../../assets/imgs/complete_sura.svg';
import ConnectCompleteImg from '../../../assets/imgs/complete_connect.svg';

import BcrUploadIcon from '../../../assets/imgs/upload-icon-bcr.svg';
import InsUserAvatar from '../../../assets/imgs/user.svg';
import InsConnectionAvanzar from '../../../assets/imgs/connection.svg';
import InsTimeAvanzar from '../../../assets/imgs/time-reload.svg';
import InsLocationAvanzar from '../../../assets/imgs/location.svg';
import InsCheckIcon from '../../../assets/imgs/check.svg';

import MnkWelcomeImg from '../../../assets/imgs/il_proceso_mnk.svg';
import MnkExteriorIcon from '../../../assets/imgs/photo-menu/i-exterior - mnk.svg';
import MnkInteriorIcon from '../../../assets/imgs/photo-menu/i-interior - mnk.svg';
import MnkDocumentIcon from '../../../assets/imgs/photo-menu/i-documento - mnk.svg';
import MnkVideoIcon from '../../../assets/imgs/photo-menu/i-360video - mnk.svg';
import MnkPlateIcon from '../../../assets/imgs/photo-placeholders/exterior/plate_mnk.svg';
import MnkFrontIcon from '../../../assets/imgs/photo-placeholders/exterior/front_mnk.svg';
import MnkLeftIcon from '../../../assets/imgs/photo-placeholders/exterior/left_mnk.svg';
import MnkRightIcon from '../../../assets/imgs/photo-placeholders/exterior/right_mnk.svg';
import MnkBackIcon from '../../../assets/imgs/photo-placeholders/exterior/back_mnk.svg';
import MnkScanIcon from '../../../assets/imgs/photo-placeholders/documents/i-scan_mnk.svg';
import MnkVinIcon from '../../../assets/imgs/photo-placeholders/interior/i-vin_mnk.svg';
import MnkSpeedometerIcon from '../../../assets/imgs/photo-placeholders/interior/i-speedometer_mnk.svg';
import MnkFinishIcon from '../../../assets/imgs/i-finalizado_mnk.svg';
import MnkUploadIcon from '../../../assets/imgs/upload-icon-mnk.svg';

export const LOGOS: { [key: string]: string } = {
  is: isLogo,
  connect: connectLogo,
  sura: suraLogo,
  bcr: bcrLogo,
  ins: insLogo,
  lafise: lafiseLogo,
  /** Placeholder: sustituir por logo MNK cuando exista el asset. */
  mnk: mnkLogo,
};

export const WelcomeImageByBrand: { [key: string]: string } = {
  is: IsWelcomeImg,
  connect: ConnectWelcomeImg,
  sura: SuraWelcomeImg,
  bcr: BcrWelcomeImg,
  lafise: LafiseWelcomeImg,
  mnk: MnkWelcomeImg,
};

export const exteriorIcon: { [key: string]: string } = {
  is: IsExteriorIcon,
  connect: ConnectExteriorIcon,
  sura: SuraExteriorIcon,
  bcr: BcrExteriorIcon,
  ins: InsExteriorIcon,
  lafise: LafiseExteriorIcon,
  mnk: MnkExteriorIcon,
};

export const interiorIcon: { [key: string]: string } = {
  is: IsInteriorIcon,
  connect: ConnectInteriorIcon,
  sura: SuraInteriorIcon,
  bcr: BcrInteriorIcon,
  ins: InsInteriorIcon,
  lafise: LafiseInteriorIcon,
  mnk: MnkInteriorIcon,
};

export const documentIcon: { [key: string]: string } = {
  is: IsDocumentIcon,
  connect: ConnectDocumentIcon,
  sura: SuraDocumentIcon,
  bcr: BcrDocumentIcon,
  ins: InsDocumentIcon,
  lafise: LafiseDocumentIcon,
  mnk: MnkDocumentIcon,
};

export const video360Icon: { [key: string]: string } = {
  is: IsVideoIcon,
  connect: ConnectVideoIcon,
  sura: SuraVideoIcon,
  bcr: BcrVideoIcon,
  ins: InsVideoIcon,
  lafise: LafiseVideoIcon,
  mnk: MnkVideoIcon,
};

export const plateIcon: { [key: string]: string } = {
  is: IsPlateIcon,
  connect: ConnectPlateIcon,
  sura: SuraPlateIcon,
  bcr: BcrPlateIcon,
  ins: InsPlateIcon,
  lafise: LafisePlateIcon,
  mnk: MnkPlateIcon,
};

export const frontSideIcon: { [key: string]: string } = {
  is: IsFrontIcon,
  connect: ConnectFrontIcon,
  sura: SuraFrontIcon,
  bcr: BcrFontIcon,
  ins: InsFontIcon,
  lafise: LafiseFrontIcon,
  mnk: MnkFrontIcon,
};

export const leftSideIcon: { [key: string]: string } = {
  is: IsLeftIcon,
  connect: ConnectLeftIcon,
  sura: SuraLeftIcon,
  bcr: BcrLeftIcon,
  ins: InsLeftIcon,
  lafise: LafiseLeftIcon,
  mnk: MnkLeftIcon,
};

export const rightSideIcon: { [key: string]: string } = {
  is: IsRightIcon,
  connect: ConnectRightIcon,
  sura: SuraRightIcon,
  bcr: BcrRightIcon,
  ins: InsRightIcon,
  lafise: LafiseRightIcon,
  mnk: MnkRightIcon,
};

export const backSideIcon: { [key: string]: string } = {
  is: IsBackIcon,
  connect: ConnectBackIcon,
  sura: SuraBackIcon,
  bcr: BcrBackIcon,
  ins: InsBackIcon,
  lafise: LafiseBackIcon,
  mnk: MnkBackIcon,
};

export const scanIcon: { [key: string]: string } = {
  is: IsScanIcon,
  connect: ConnectScanIcon,
  sura: SuraScanIcon,
  bcr: BcrScanIcon,
  ins: InsScanIcon,
  lafise: LafiseScanIcon,
  mnk: MnkScanIcon,
};

export const interiorPlaceIcon: { [key: string]: string } = {
  is: IsInteriorPlaceIcon,
  connect: ConnectInteriorPlaceIcon,
  sura: SuraInteriorPlaceIcon,
  bcr: BcrInteriorPlaceIcon,
  ins: InsInteriorPlaceIcon,
  lafise: LafiseInteriorPlaceIcon,
};

export const vinIcon: { [key: string]: string } = {
  is: IsVinIcon,
  connect: ConnectVinIcon,
  sura: SuraVinIcon,
  bcr: BcrVinIcon,
  ins: InsVinIcon,
  lafise: LafiseVinIcon,
  mnk: MnkVinIcon,
};

export const speedometerIcon: { [key: string]: string } = {
  is: IsSpeedometerIcon,
  connect: ConnectSpeedometerIcon,
  sura: SuraSpeedometerIcon,
  bcr: BcrSpeedometerIcon,
  ins: InsSpeedometerIcon,
  lafise: LafiseSpeedometerIcon,
  mnk: MnkSpeedometerIcon,
};

export const dekraIcon: { [key: string]: string } = {
  is: IsDekraIcon,
  connect: ConnectDekraIcon,
  sura: defaultImg,
  bcr: BcrDekraIcon,
  ins: InsDekraIcon,
  lafise: LafiseDekraIcon,
};

export const trunkIcon: { [key: string]: string } = {
  is: IsTrunkIcon,
  connect: ConnectTrunkIcon,
  sura: SuraTrunkIcon,
  bcr: BcrTrunkIcon,
  ins: InsTrunkIcon,
  lafise: LafiseTrunkIcon,
};

export const finishIcon: { [key: string]: string } = {
  is: IsfinishIcon,
  connect: ConnectFinishIcon,
  sura: SuraFinishIcon,
  bcr: BcrFinishIcon,
  ins: InsFinishIcon,
  lafise: LafiseFinishIcon,
  mnk: MnkFinishIcon,
};

export const uploadIcon: { [key: string]: string } = {
  bcr: BcrUploadIcon,
  lafise: BcrUploadIcon,
  mnk: MnkUploadIcon,
};

export const completeImg: {
  [key: string]: { source: string; width: number; height?: number };
} = {
  is: { source: IsCompleteImg, width: 250, height: 250 },
  connect: { source: ConnectCompleteImg, width: 250, height: 250 },
  sura: { source: SuraCompleteImg, width: 250, height: 250 },
  bcr: { source: bcrLogo, width: 300, height: 200 },
  ins: { source: insLogo, width: 300, height: 200 },
  lafise: { source: lafiseLogo, width: 300, height: 200 },
  mnk: { source: mnkLogo, width: 300, height: 200 },
};

export const WelcomeItemsMsg: {
  [key: string]: {conditions: {_array: true, items: {key: string, icon: string}[]}} | undefined 
} = {
  ins: {
		conditions: {
			_array: true,
      items: [
        { key: 'policyHolder', icon: InsUserAvatar },
        { key: 'internetConnection', icon: InsConnectionAvanzar },
        { key: 'timeAvailable', icon: InsTimeAvanzar },
        { key: 'locationPermission', icon: InsLocationAvanzar }
      ]
		}
	}
}

export const AdviceMsg: {
  [key: string]: {_array: true, items: {key: string, icon: string}[]} | undefined 
} = {
  ins: {
      _array: true,
      items: [
        { 
          key: 'photos', 
          icon: InsCheckIcon
        },
        { 
          key: 'technicalReview', 
          icon: InsCheckIcon
        }
      ]
  }
} 
